(() => {
    const plansTab = document.querySelectorAll('.plans-list-tab');
    const tabs = document.querySelectorAll('.tab-checkbox');
    const tab1 = document.querySelectorAll('.tab-1');
    const tab2 = document.querySelectorAll('.tab-2');
    const tab3 = document.querySelectorAll('.tab-3');

    plansTab.forEach(tab => {
        tab.addEventListener('click', e => {
            e.preventDefault();

            // remove active class for tab
            plansTab.forEach(allTabs => {
                allTabs.classList.remove('active');
            });

            e.currentTarget.classList.add('active');

            // hide all checkbox tabs
            tabs.forEach(allTabs => {
                allTabs.classList.remove('tab-hidden');
            });

            if (e.currentTarget.dataset.tab === 'tab1') {
                tab1.forEach(tab => tab.classList.remove('tab-hidden'));
                tab2.forEach(tab => tab.classList.add('tab-hidden'));
                tab3.forEach(tab => tab.classList.add('tab-hidden'));
            } else if (e.currentTarget.dataset.tab === 'tab2') {
                tab1.forEach(tab => tab.classList.add('tab-hidden'));
                tab2.forEach(tab => tab.classList.remove('tab-hidden'));
                tab3.forEach(tab => tab.classList.add('tab-hidden'));
            } else if (e.currentTarget.dataset.tab === 'tab3') {
                tab1.forEach(tab => tab.classList.add('tab-hidden'));
                tab2.forEach(tab => tab.classList.add('tab-hidden'));
                tab3.forEach(tab => tab.classList.remove('tab-hidden'));
            }
        });
    });

    // sticky scroll from mobile
    window.addEventListener('scroll', () => {
        const plansList = document.querySelector('.plans-list-mobile-sticky');
        const table = document.querySelector('.table');

        /*
         ** table.getBoundingClientRect().top < size of nav (72) && < size of .plans-list-mobile-container
         */
        if (plansList) {
            if (
                table.getBoundingClientRect().top <= 178 &&
                table.getBoundingClientRect().bottom - 128 >= 0
            ) {
                plansList.classList.add('sticky');
            } else {
                plansList.classList.remove('sticky');
            }
        }
    });
})();
